import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import HpvTestResultImportView from 'components/lab-central/HpvTestResultImportView';
import NoPoolAvailableTestkitView from 'components/lab-central/NoPoolAvailableTestkitView';
import PoolTestkitSingularizationView
  from 'components/lab-central/pool-testkit-singularization/PoolTestkitSingularizationView';
import PoolTestRegistration from 'components/lab-central/PoolTestRegistration';
import TestAuthorityNotificationView
  from 'components/lab-central/test-authority-notification/TestAuthorityNotificationView';
import TestKitReceptionView from 'components/lab-central/TestKitReceptionView';
import TestResultImportView from 'components/lab-central/TestResultImportView';
import SectionContainer from 'components/section/SectionContainer';
import { SectionPage } from 'components/section/SectionPage';
import React from 'react';

interface Props extends AuthConsumerRenderProps {

}

const LabCentralHome = (props: Props) => {
  const pages: SectionPage[] = [
    {
      id: "testKitReception",
      uri: "/lab-central/testkit-reception",
      component: TestKitReceptionView
    },
    {
      id: "poolTestkitRegistration",
      uri: "/lab-central/pool-test-registration",
      component: PoolTestRegistration
    },
    {
      id: "poolTestKitSingularization",
      uri: "/lab-central/pool-testkit-singularization",
      component: PoolTestkitSingularizationView
    },
    {
      id: "noPoolAvailableTestkit",
      uri: "/lab-central/no-pool-available-testkit",
      component: NoPoolAvailableTestkitView
    },
    {
      id: "importTestResult",
      uri: "/lab-central/import-test-result",
      component: TestResultImportView
    },
    {
      id: "importHpvTestResult",
      uri: "/lab-central/import-hpv-test-result",
      component: HpvTestResultImportView
    },
    {
      id: "testAuthorityNotification",
      uri: "/lab-central/test-authority-notification",
      component: TestAuthorityNotificationView
    }
  ];

  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withAuthContext(LabCentralHome);
